import { getCheckoutSessionById } from '@nemuru-eng/js-api-client';

import { useCache } from '@/hooks/requests/useCache';

export const useGetCheckoutSessionById = (checkoutSessionId: string | undefined) => {
  if (!checkoutSessionId) return { checkoutSession: undefined };

  const {
    data: checkoutSession,
    loading,
    revalidate,
    resetCache,
  } = useCache(
    getCheckoutSessionById,
    {
      checkoutSessionId,
    },
    { revalidateIfStale: false },
  );

  return {
    checkoutSession,
    loading,
    revalidate,
    resetCache,
  };
};
